
export default {
  name: 'not-found',
  props: ['error'],
  layout: 'server-render'
}
